<div class="purchaseorder-container">
  <div class="purchaseorder-header">
    <h2>{{ purchaseOrderId ? (isEditMode ? 'Edit Purchase Order' : 'View Purchase Order') : 'Create New Purchase Order' }}</h2>
    <div class="header-actions">
      <button *ngIf="purchaseOrderId && !isEditMode" mat-icon-button (click)="downloadPdf()" type="button" matTooltip="Create PDF">
        <mat-icon>picture_as_pdf</mat-icon>
      </button>
      <button *ngIf="purchaseOrderId && !isEditMode" mat-raised-button color="accent" (click)="enterEditMode()" type="button">
        <mat-icon>edit</mat-icon> Edit
      </button>
    </div>
  </div>
  
  <!-- Related Records -->
  <mat-expansion-panel *ngIf="salesOrders.length > 0 || salesInvoices.length > 0 || purchaseOrderId" class="related-section" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Related</mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngIf="salesOrders.length > 0 || purchaseOrderId" class="related-subsection">
      <div class="related-subsection-header">
        <h4>Sales Orders</h4>
        <button *ngIf="isEditMode && purchaseOrderId" mat-icon-button color="primary" type="button" (click)="openLinkDialog()" matTooltip="Link existing sales order">
          <mat-icon>add_link</mat-icon>
        </button>
        <button *ngIf="!isEditMode && purchaseOrderId" mat-icon-button color="accent" type="button" (click)="generateSalesOrder()" matTooltip="Copy to new sales order">
          <mat-icon>post_add</mat-icon>
        </button>
      </div>
      <table *ngIf="salesOrders.length > 0" mat-table [dataSource]="salesOrders" class="related-table">
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef>Order #</th>
          <td mat-cell *matCellDef="let so">{{ so.number }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let so">{{ so.date | date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let so">{{ so.status }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let so">{{ so.totalAmount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let so">
            <button mat-icon-button color="primary" (click)="viewSalesOrder(so.id); $event.stopPropagation()" type="button" matTooltip="View Sales Order">
              <mat-icon>open_in_new</mat-icon>
            </button>
            <button *ngIf="isEditMode" mat-icon-button color="warn" (click)="removeSalesOrder(so.id); $event.stopPropagation()" type="button" matTooltip="Remove from related">
              <mat-icon>link_off</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="salesOrderColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: salesOrderColumns;" class="clickable-row" (click)="viewSalesOrder(row.id)"></tr>
      </table>
    </div>

    <div *ngIf="salesInvoices.length > 0" class="related-subsection">
      <div class="related-subsection-header">
        <h4>Sales Invoices</h4>
      </div>
      <table mat-table [dataSource]="salesInvoices" class="related-table">
        <ng-container matColumnDef="invoiceNumber">
          <th mat-header-cell *matHeaderCellDef>Invoice #</th>
          <td mat-cell *matCellDef="let si">{{ si.invoiceNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let si">{{ si.date | date:'MM/dd/yyyy' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let si">{{ si.status }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let si">{{ si.totalAmount | currency }}</td>
        </ng-container>
        <ng-container matColumnDef="siActions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let si">
            <button mat-icon-button color="primary" (click)="viewSalesInvoice(si.id); $event.stopPropagation()" type="button" matTooltip="View Sales Invoice">
              <mat-icon>open_in_new</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="salesInvoiceColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: salesInvoiceColumns;" class="clickable-row" (click)="viewSalesInvoice(row.id)"></tr>
      </table>
    </div>
  </mat-expansion-panel>

  <form [formGroup]="purchaseOrderForm" (ngSubmit)="onSubmit()" class="purchaseorder-form" [class.view-mode]="!isEditMode">
    <!-- Order Information Section -->
    <h3>Order Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Order Number</mat-label>
        <input matInput formControlName="number" placeholder="Enter order number" [readonly]="!isEditMode">
        <mat-error *ngIf="purchaseOrderForm.get('number')?.hasError('required')">
          Order number is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Order Date</mat-label>
        <input matInput [matDatepicker]="orderDatePicker" formControlName="date" [readonly]="!isEditMode">
        <mat-datepicker-toggle matSuffix [for]="orderDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
        <mat-datepicker #orderDatePicker></mat-datepicker>
        <mat-error *ngIf="purchaseOrderForm.get('date')?.hasError('required')">
          Order date is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status" [disabled]="!isEditMode">
          <mat-option *ngFor="let status of orderStatuses" [value]="status.name">{{ status.description }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Vendor Information Section -->
    <h3>Vendor Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Vendor</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input matInput 
               formControlName="vendorSearch" 
               placeholder="Search vendor by name or ID"
               [readonly]="!isEditMode"
               [matAutocomplete]="autoVendor">
        <button mat-icon-button matSuffix 
                *ngIf="purchaseOrderForm.get('vendorSearch')?.value && isEditMode"
                (click)="clearVendor(); $event.stopPropagation()"
                type="button"
                matTooltip="Clear vendor">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #autoVendor="matAutocomplete" 
                          [displayWith]="displayVendor.bind(this)"
                          (optionSelected)="onVendorSelected($event.option.value)">
          <mat-option *ngFor="let vendor of filteredVendors | async" [value]="vendor">
            {{ vendor.name || vendor.Name }} (ID: {{ vendor.id || vendor.Id }})
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="purchaseOrderForm.get('vendorId')?.hasError('required')">
          Vendor is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field" style="display: none;">
        <mat-label>QuickBooks ID</mat-label>
        <input matInput type="number" formControlName="qboId" placeholder="Enter QuickBooks ID">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Vendor Address</mat-label>
        <mat-select formControlName="vendorAddressId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let address of vendorAddresses" [value]="address.id || address.Id">
            {{ formatAddress(address) }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="purchaseOrderForm.get('vendorAddressId')?.value"
          [matTooltip]="getAddressTooltip(purchaseOrderForm.get('vendorAddressId')?.value, vendorAddresses)"
          style="cursor:help;font-size:16px;opacity:0.6;">info_outline</mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Vendor Contact</mat-label>
        <mat-select formControlName="vendorContactId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let contact of vendorContacts" [value]="contact.id || contact.Id">
            {{ contact.firstName || contact.FirstName }} {{ contact.lastName || contact.LastName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Sales Person</mat-label>
        <input matInput formControlName="salesPerson" placeholder="Enter sales person name" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <!-- Shipping Information Section -->
    <h3>Shipping Information</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Shipper</mat-label>
        <input matInput formControlName="shipper" placeholder="Enter shipper name" [readonly]="!isEditMode">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Ship Account Number</mat-label>
        <input matInput formControlName="shipAccountNum" placeholder="Enter account number" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Ship Terms</mat-label>
        <input matInput formControlName="shipTerms" placeholder="Enter shipping terms" [readonly]="!isEditMode">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Desired Ship Date</mat-label>
        <input matInput [matDatepicker]="shipDatePicker" formControlName="desiredShipDate" [readonly]="!isEditMode">
        <mat-datepicker-toggle matSuffix [for]="shipDatePicker" [disabled]="!isEditMode"></mat-datepicker-toggle>
        <mat-datepicker #shipDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field-full">
        <mat-label>Ship Attention To</mat-label>
        <input matInput formControlName="shipAttentionTo" placeholder="Attention to name" [readonly]="!isEditMode">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Shipping Address</mat-label>
        <mat-select formControlName="shippingAddressId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let address of internalShippingAddresses" [value]="address.id || address.Id">
            {{ formatAddress(address) }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="purchaseOrderForm.get('shippingAddressId')?.value"
          [matTooltip]="getAddressTooltip(purchaseOrderForm.get('shippingAddressId')?.value, internalShippingAddresses)"
          style="cursor:help;font-size:16px;opacity:0.6;">info_outline</mat-icon>
      </mat-form-field>
    </div>

    <!-- Products Section -->
    <div class="section-header">
      <h3>Products</h3>
      <button mat-mini-fab color="primary" type="button" (click)="addProduct()" matTooltip="Add Product" *ngIf="isEditMode">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <mat-accordion formArrayName="products">
      <mat-expansion-panel *ngFor="let product of products.controls; let i = index" [formGroupName]="i">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ getProductTitle(i) }}
          </mat-panel-title>
          <mat-panel-description>
            <button mat-icon-button color="warn" type="button" (click)="removeProduct(i); $event.stopPropagation()" matTooltip="Remove Product" *ngIf="isEditMode">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-panel-description>
        </mat-expansion-panel-header>
        
        <div class="form-row">
          <input type="hidden" formControlName="productId">
          <input type="hidden" formControlName="lotNumId">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Product</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput
                   formControlName="productSearch"
                   placeholder="Search by name, catalog #, lot #, or vendor catalog #"
                   [readonly]="!isEditMode"
                   [matAutocomplete]="autoProduct">
            <button mat-icon-button matSuffix
                    *ngIf="product.get('productSearch')?.value && isEditMode"
                    (click)="clearProduct(i); $event.stopPropagation()"
                    type="button"
                    matTooltip="Clear product">
              <mat-icon>close</mat-icon>
            </button>
            <mat-autocomplete #autoProduct="matAutocomplete"
                              [displayWith]="displayProduct.bind(this)"
                              (optionSelected)="onProductSelected(i, $event.option.value)">
              <mat-option *ngFor="let p of filteredProductsList[i] | async" [value]="p">
                {{ p.displayLabel }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="product.get('productId')?.hasError('required')">
              Product is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>FITZIDX Catalog #</mat-label>
            <input matInput formControlName="catalogNum" placeholder="Auto-filled from product" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>FITZIDX Lot Number</mat-label>
            <input matInput formControlName="fitzidxLotNumber" readonly>
          </mat-form-field>          
        </div>

         <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Description</mat-label>
            <input matInput formControlName="description" placeholder="Auto-filled from product" readonly>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field" *ngIf="purchaseOrderForm.get('vendorId')?.value == 38">
            <mat-label>Part Number</mat-label>
            <input matInput formControlName="partNum" placeholder="Enter part number" [readonly]="!isEditMode">
          </mat-form-field>
         </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Vendor Catalog #</mat-label>
            <input matInput formControlName="vendorCatalogNum" [readonly]="!isEditMode">
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Vendor Lot #</mat-label>
            <input matInput formControlName="vendorLotNum" [readonly]="!isEditMode">
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Desired Packaging</mat-label>
            <input matInput formControlName="desiredPackaging" [readonly]="!isEditMode">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Unit Price</mat-label>
            <input matInput type="number" formControlName="unitPrice" placeholder="0.00" step="0.01" [readonly]="!isEditMode">
            <span matPrefix>$&nbsp;</span>
            <mat-error *ngIf="product.get('unitPrice')?.hasError('required')">
              Unit price is required
            </mat-error>
            <mat-error *ngIf="product.get('unitPrice')?.hasError('min')">
              Price must be positive
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Quantity</mat-label>
            <input matInput type="number" formControlName="quantity" placeholder="1" step="0.01" [readonly]="!isEditMode">
            <mat-error *ngIf="product.get('quantity')?.hasError('required')">
              Quantity is required
            </mat-error>
            <mat-error *ngIf="product.get('quantity')?.hasError('min')">
              Quantity must be greater than 0
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Unit Type</mat-label>
            <mat-select formControlName="unitType" [disabled]="!isEditMode">
              <mat-option *ngFor="let type of unitTypes" [value]="type">{{ type | titlecase }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field" style="display: none;">
            <mat-label>Line Number</mat-label>
            <input matInput type="number" formControlName="lineNumber" readonly>
          </mat-form-field>
        </div>

        <!-- <div class="form-row">
          <mat-form-field appearance="outline" class="form-field-full">
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="notes" rows="2" placeholder="Line item notes" [readonly]="!isEditMode"></textarea>
          </mat-form-field>
        </div> -->
      </mat-expansion-panel>

      <div *ngIf="products.length === 0" class="empty-message">
        No products added. Click + to add a product line.
      </div>
    </mat-accordion>

    <!-- Financial Information Section -->
    <h3>Financial Information</h3>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Billing Address</mat-label>
        <mat-select formControlName="billingAddressId" [disabled]="!isEditMode">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let address of internalShippingAddresses" [value]="address.id || address.Id">
            {{ formatAddress(address) }}
          </mat-option>
        </mat-select>
        <mat-icon matSuffix *ngIf="purchaseOrderForm.get('billingAddressId')?.value"
          [matTooltip]="getAddressTooltip(purchaseOrderForm.get('billingAddressId')?.value, internalShippingAddresses)"
          style="cursor:help;font-size:16px;opacity:0.6;">info_outline</mat-icon>
      </mat-form-field>
    </div>

     <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Ship Fee</mat-label>
        <input matInput type="number" formControlName="shipFee" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="purchaseOrderForm.get('shipFee')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Handling Fee</mat-label>
        <input matInput type="number" formControlName="handlingFee" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="purchaseOrderForm.get('handlingFee')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Discount Amount</mat-label>
        <input matInput type="number" formControlName="discountAmount" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="purchaseOrderForm.get('discountAmount')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Tax Amount</mat-label>
        <input matInput type="number" formControlName="taxAmount" placeholder="0.00" [readonly]="!isEditMode">
        <span matPrefix>$&nbsp;</span>
        <mat-error *ngIf="purchaseOrderForm.get('taxAmount')?.hasError('min')">
          Amount must be positive
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field-full">
        <mat-label>Additional Notes to Customer</mat-label>
        <textarea matInput formControlName="notes" rows="3" placeholder="Additional Notes to Customer" [readonly]="!isEditMode"></textarea>
      </mat-form-field>
    </div>

    <!-- Order Total Section -->
    <div *ngIf="products.length > 0" class="total-section">
      <div class="total-row">
        <span class="total-label">Subtotal:</span>
        <span class="total-amount">{{ getLineItemsTotal() | currency }}</span>
      </div>
      <div class="total-row" *ngIf="purchaseOrderForm.get('discountAmount')?.value > 0">
        <span class="total-label discount">Discount:</span>
        <span class="total-amount discount">-{{ purchaseOrderForm.get('discountAmount')?.value | currency }}</span>
      </div>
      <div class="total-row" *ngIf="purchaseOrderForm.get('taxAmount')?.value > 0">
        <span class="total-label">Tax:</span>
        <span class="total-amount">{{ purchaseOrderForm.get('taxAmount')?.value | currency }}</span>
      </div>
      <div class="total-row" *ngIf="purchaseOrderForm.get('shipFee')?.value > 0">
        <span class="total-label">Shipping:</span>
        <span class="total-amount">{{ purchaseOrderForm.get('shipFee')?.value | currency }}</span>
      </div>
      <div class="total-row" *ngIf="purchaseOrderForm.get('handlingFee')?.value > 0">
        <span class="total-label">Handling Fee:</span>
        <span class="total-amount">{{ purchaseOrderForm.get('handlingFee')?.value | currency }}</span>
      </div>
      <div class="total-row total-highlight">
        <span class="total-label">Order Total:</span>
        <span class="total-amount">{{ calculateTotal() | currency }}</span>
      </div>
    </div>

    <div class="form-actions" *ngIf="isEditMode">
      <button mat-raised-button color="primary" type="submit" [disabled]="!purchaseOrderForm.valid">
        Save
      </button>
      <button mat-raised-button type="button" (click)="onCancel()">
        Cancel
      </button>
    </div>

  </form>
</div>
